import { Injectable } from '@angular/core';
import { TagModel } from '@models';

@Injectable({
    providedIn: 'root',
})
export class Helper {
    constructor() {}

    /**
     *
     * @param template string with or without tags ej: Hello {{name}}!
     * @param tags object with key value. ej: {key:name, value: John}
     * @returns with this examples: Hello John!
     */
    replaceTemplateTags(template: string, tags: TagModel[]): string {
        Object.keys(tags).forEach((key) => {
            const strKey = `{{${key}}}`;
            template = template.split(strKey).join(tags[key]);
        });
        return template;
    }

    createImageFromBlob(image: Blob): Promise<string | ArrayBuffer> {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.addEventListener(
                'load',
                () => {
                    resolve(reader.result);
                },
                false
            );

            if (image) {
                reader.readAsDataURL(image);
            }
        });
    }
}
